import React, { useEffect, useState } from "react";
import "suneditor/dist/css/suneditor.min.css";
// import 'suneditor/assets/css/suneditor.css'
import "./TextEditor.css";
import SunEditor from "suneditor-react";
import plugins from "suneditor/src/plugins";
import { useRef } from "react";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const TextEditor = ({ defaultValue }) => {
  const [editorContent, setEditorContent] = useState("");

  const handleEditorStateChange = (content) => {
    setEditorContent(content);
  };
  return (
    <div className="xl:max-w-[780px] xl:h-[478px]">
      <input
        type="text"
        placeholder="Enter Post Title"
        className="bg-[#23242B]  gradient-box w-full mt-[10px] pt-[10px] pb-[11px] text-res-xs font-medium text-center h-[40px]  "
      />
      {/* <Editor
        toolbar={{
          options: [
            "history",
            "blockType",
            "fontSize",
            "fontFamily",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "embedded",
            "emoji",
            "image",
            "remove",
          ],
          blockType: {
            inDropdown: true,

            options: [
              "Normal",
              "H1",
              "H2",
              "H3",
              "H4",
              "H5",
              "H6",
              "Blockquote",
              "Code",
            ],
          },
        }}
        editorState={editorContent}
        onEditorStateChange={handleEditorStateChange}
      /> */}
      <SunEditor
        setContents={defaultValue}
        setOptions={{
          //   font: ["NormalText", "tohoma", "Courier New,Courier"],
          height: 478,
          formats: ["p", "div", "h1", "h2", "h3", "h4", "h5", "h6"],
          buttonList: [
            [
              "undo",
              "redo",
              "formatBlock",
              "align",
              "fontColor",
              "bold",
              "italic",
              "underline",
              "strike",
              "removeFormat",
              "align",
              "list",
              "link",
              "image",
              "codeView",
              "blockquote",
              "horizontalRule",
            ],
          ],
          list: { isDropdown: false },
        }}
        setDefaultStyle="background-color: black; color: white;     font-size: 16px; letter-spacing: 0.06em; font-weight: 500; line-height: 22px;"
      />
    </div>
  );
};

export default TextEditor;
